import { useNavigate } from 'react-router-dom';
import { Camera } from 'lucide-react';
import clsx from 'clsx';

export function CaptureButton({ variant = 'floating' }: { variant?: 'floating' | 'large' }) {
  const navigate = useNavigate();
  if (variant === 'large') {
    return (
      <button
        onClick={() => navigate('/capture')}
        className="w-full py-5 rounded-lg text-white font-medium text-body-lg flex items-center justify-center gap-3 shadow"
        style={{ background: 'linear-gradient(135deg, #E94D2C 0%, #B83518 100%)' }}
      >
        <Camera size={20} /> Capture something
      </button>
    );
  }
  return (
    <button
      onClick={() => navigate('/capture')}
      className={clsx(
        'fixed bottom-7 right-7 w-16 h-16 rounded-full text-white shadow-lg flex items-center justify-center z-50',
      )}
      style={{ background: 'linear-gradient(135deg, #E94D2C 0%, #B83518 100%)' }}
      aria-label="Capture"
    >
      <Camera size={24} />
    </button>
  );
}
